import { InputLabel, OutlinedInput, TextField } from "@mui/material";
import { styled } from "@mui/system";

export const StyledTextField = styled(TextField)`
  label.Mui-focused {
    color: black;
  }
  label {
    color: black;
  }
`;

export const StyledOutlinedInput = styled(OutlinedInput)`
  input {
    color: black;
  }

  label {
    color: black;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: black;
  }
`;

export const StyledInputLabel = styled(InputLabel)`
  input {
    color: black;
  }

  label {
    color: black !important;
  }

  .MuiInputLabel-root.Mui-focused {
    color: black;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: black;
  }
`;
